module.exports = __webpack_public_path__ + "img/bird_header.d424e459.png";